'use client';

import { usePathname } from 'next/navigation';
import { useEffect } from 'react';

import { useCacheKey, useDeviceType, useOptimizely } from '../hooks';
import { resolveScripts } from './scripts.registry';

type ScriptsProps = {
    pageType: string;
};

export const Scripts = ({ pageType }: ScriptsProps) => {
    const { init } = useOptimizely();
    const { cookies, headers } = useCacheKey();
    const pathname = usePathname();
    const { deviceType } = useDeviceType();
    const scriptEntries = resolveScripts(pageType);
    const team = cookies.get('x-petm-team');
    const isBot = headers.has('x-petm-bot');

    useEffect(() => {
        if (pathname) init({ pathname, deviceType, team, isBot });
    }, [init, pathname, deviceType]);

    return (
        <>
            {scriptEntries.map(({ id, Component }) => (
                <Component key={id} />
            ))}
        </>
    );
};
